import api from '@/api/Api'
import LoginModel from '@/model/LoginModel'
import store from '@/store'
import logger from '@/assets/log'
import config from '@/config'
import helper from "@/assets/helper.js";
const log = logger("store:user");

// initial state
// shape: [{ id, quantity }]
const state = {
    id: null,
    name: null,
    logoutUrl: null,
    indexUrl: null,
    status: null,
    centerUserId: null,
    auditStatus: null,
    permissionList: [],
    globalConfig: {},
    userCode:null,
    departmentMenus:[],
    hasDepartmentMenus:0,
    userGroupList:[],
    defaultSelectedUserGroup:null,
    originDefaultSelectedUserGroup:null
}

// getters
const getters = {
}

// actions
const actions = {
    toLogin({ commit, state }, { loginUrl, platformCode, sid }) {
        if(loginUrl)
            LoginModel.toLoginPage(loginUrl, platformCode, sid)
    },
    async login({ commit, state }) {


        let token = LoginModel.getToken();

        commit("status", "loading");

        log("(:/login) token=%s", token);

		let ret;
        try {
			ret = await api.call("user/getUserInfo", {}, { token })
            //如果url上有token ，则去掉token 重新加载。
            if (LoginModel.onLogin()) {

                commit("login", {
                    id: ret.data.userId,
                    name: ret.data.userName,
                    logoutUrl: ret.data.logoutUrl,
                    indexUrl: ret.data.indexUrl,
                    centerUserId: ret.centerUserId,
                    auditStatus: ret.data.auditStatus,
                    userCode: ret.data.userCode,
                });
                
                log("(:/login) done");
            }
        } catch (e) {
            if (e.result !== undefined && e.loginUrl) {
                commit("status", "fail")
                log("(:/login) offline: %o", e);
                LoginModel.toLoginPage(e.loginUrl, e.platformCode, e.sid)
            }
            else {
                commit("status", "error");
                log.warn("(:/login) failed: %o", e);
			}
			return;
		}
		
		try {
			
            let userGropuRet = await api.call("user/shareGroupList",{})
            let departmentRet = await api.call("department/getDepList", {}, true);
            let tree = null;
            let hasDepartmentMenus = 0;
            if(departmentRet.data.length>0){
                hasDepartmentMenus = 1;
                tree = helper.getTree(departmentRet.data, 'pId', departmentRet.data[0].pId);
                helper.travel(tree, "children", n => {
                    n.title = n.name.length>10?n.name.substring(0,8)+"...":n.name;
                    n.checked = false;
                    n.expand = false;
                });
            }

            // if(tree[0]) {
            //     tree[0].expand = true;
            // }
            //如果url上有token ，则去掉token 重新加载。
            if (LoginModel.onLogin()) {

                commit("login", {
                    id: ret.data.userId,
                    name: ret.data.userName,
                    logoutUrl: ret.data.logoutUrl,
                    indexUrl: ret.data.indexUrl,
                    centerUserId: ret.centerUserId,
                    auditStatus: ret.data.auditStatus,
                    userCode: ret.data.userCode,
                    userGroupList:userGropuRet.list,
                    defaultSelectedUserGroup:userGropuRet.list.length>0?userGropuRet.list[0].id:null,
                    originDefaultSelectedUserGroup:userGropuRet.list.length>0?userGropuRet.list[0].id:null,
                    departmentMenus:tree,
                    hasDepartmentMenus:hasDepartmentMenus
                });

                store.commit("department/current", {
                    id: (ret.data.depId!=undefined)?ret.data.depId:0,
                    name: ret.data.depName
                });
                store.commit("department/currentDepLevel", {
                    depLevel: ret.data.depLevel
                });
            }

            let globalConfig = await api.call("user/getGlobalConfig");
            commit('setGlobalConfig', globalConfig.data);
		} catch (e) {
			log.warn("(:/login) error: %o", e);
		}
    },
    async logout({ commit, state }) {

        commit("logout");
        log("(:/login) logout");
        LoginModel.toLogoutPage(state.logoutUrl);

    },
    async toUserCenter({ commit, state }) {
        location.href = state.indexUrl;
    },
    async toMaterialCms({ commit, state }) {
        location.href = config.materialCmsWeb;
    },
    async toAdminCenter({ commit, state }) {
        location.href = config.AdminCenter;
    }
}

// mutations
const mutations = {
    status(state, newStatus) {
        state.status = newStatus;
    },
    login(state, { id, name, logoutUrl, indexUrl, centerUserId, auditStatus, userCode, userGroupList,defaultSelectedUserGroup,originDefaultSelectedUserGroup,departmentMenus,hasDepartmentMenus}) {
        state.hasDepartmentMenus = hasDepartmentMenus;
        state.status = "online";
        state.id = id;
        state.name = name;
        state.logoutUrl = logoutUrl;
        state.indexUrl = indexUrl;
        state.centerUserId = centerUserId;
        state.auditStatus = auditStatus;
        state.userCode = userCode;
        state.userGroupList = userGroupList;
        state.defaultSelectedUserGroup = defaultSelectedUserGroup;
        state.departmentMenus = departmentMenus;
        state.originDefaultSelectedUserGroup = originDefaultSelectedUserGroup;
    },
    logout(state) {
        state.status = "offline";
        state.name = null;
        state.id = null;
    },
    setGlobalConfig(state, globalConfig){
        state.globalConfig = globalConfig
    },
    setDefaultSelectedUserGroup(state,defaultSelectedUserGroup){
        state.defaultSelectedUserGroup = defaultSelectedUserGroup
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}